import { calculateResponsiveSize, mediaMax } from 'styles/media-queries'
import styled from 'styled-components'

export const Section = styled.div`
  width: 100%;
  transition: 1s;
  transition-timing-function: linear;
  background: var(--black);
  position: fixed;
  z-index: 8;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  height: 0;
  overflow: hidden;
  &.opened {
    height: 100dvh;
  }
`
